<div class="form-group row" [ngClass]="[
		!isDirty && hasRequiredField  ? 'required' : '',
		isDirty && !isControlInValid ? 'has-success' : '',
		isDirty && isControlInValid ? 'has-error' : ''
	]">
	<div *ngIf="labelSlotPresent" class="col-sm-3 control-label">
		<ng-content></ng-content>
	</div>
	<div [ngClass]="isControlOnly ? 'col-sm-12' : 'col-sm-9'">
		<div class="row">
			<div [ngClass]="isControlOnly ? 'col-sm-12' : 'col-sm-6'">
				<ng-content select="[uiControl]"></ng-content>
				<span [ngClass]="[
					noValidation ? '' : 'required-field',
					styles.glyphiconsWrapper
				]">
				</span>
				<span [ngClass]="[
					noValidation ? '' : 'success-field',
					styles.glyphiconsWrapper
				]"></span>
			</div>
		</div>
		<div *ngIf="isDirty" class="padding-left-0" [ngClass]="isControlOnly ? 'col-sm-12' : 'col-sm-6'">
			<ng-content select="[uiValidation]"></ng-content>
		</div>
	</div>
</div>

